import { List, ListItem, Typography } from '@mui/material'

import { GetSmsTemplateTokensQuery } from 'generated/graphql'

interface IProps {
  tokens?: GetSmsTemplateTokensQuery['smsTemplateTokens']
}

const SmsTokens = (props: IProps) => {
  const { tokens } = props

  return (
    <List>
      {tokens?.map((token) => (
        <ListItem key={token.numericValue}>
          <Typography>
            <strong>{token.token}</strong>
            {' - '}
            {token.description}
          </Typography>
        </ListItem>
      ))}
    </List>
  )
}

export default SmsTokens
